module.exports = __webpack_public_path__ + "img/index8.0dc3f102.png";